import _Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import './services'
import 'src/common/globalCommon'
import swal from 'sweetalert2'
import i18n from './i18n'

// utils
import { modalDeSucesso, modalDeErro, modalDeInformacao, modalDeConfirmacao } from 'src/utils'

// CSS
import '../static/css/transitions.css'
import '../static/css/general.css'
import '../static/css/animations.css'
import '../static/icons/style.css'
import '../static/icons/novo/chapados/style.css'
import '../static/icons/novo/pequenos/style.css'
import '../static/icons/novo/grandes/style.css'

import '../static/css/onlyNecessaryBootstrap/bootstrap.css'
import '../node_modules/sweetalert2/dist/sweetalert2.css'
import '../static/css/variables.css' // Just Test
import 'viewerjs/dist/viewer.css'

// Third party components
import * as uiv from 'uiv'
import VModal from 'vue-js-modal'
import vClickOutside from 'v-click-outside'
import VueTheMask from 'vue-the-mask'
import VCalendar from 'v-calendar'
import * as VueGoogleMaps from 'vue2-google-maps'
import amplitude from 'amplitude-js'
import Viewer from 'v-viewer'

// Migration stuff
import localeMoment from '../static/js/pt-br'
import moment from 'moment'
import './directives'
import './filters'
import vueShortkey from 'vue-shortkey'
import Validations from 'vuelidate'
import { VNode } from 'vue/types/umd'

_Vue.use(Validations)

_Vue.use(vueShortkey, { prevent: ['input', 'textarea'] })
/* eslint-disable  @typescript-eslint/no-explicit-any */
declare global {
  interface Window {
    jQuery: any;
  }
}
/* eslint-enable  @typescript-eslint/no-explicit-any */
window.jQuery = require('jquery')
moment.updateLocale('pt-br', localeMoment)

_Vue.use(uiv, { prefix: 'uiv' })
_Vue.use(VModal)

_Vue.use(VueTheMask)

_Vue.use(vClickOutside)

// local: 789aafa26e9b6b3036ac1cf7cba377bc
amplitude.getInstance().init(process.env.VUE_APP_AMPLITUDE as string)

_Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyAlUctfv8CKCv29n339XstjTu8gvmXd8lw',
    libraries: 'places'
  }
})

_Vue.use(VCalendar, {
  locales: {
    'pt-PT': {
      firstDayOfWeek: 1
    }
  }
})
/* eslint-disable  @typescript-eslint/no-explicit-any */
const swalPlugin = {
  install (Vue: typeof _Vue, options?: any): void {
    Vue.prototype.$swal = swal
    Vue.prototype.$modalDeSucesso = modalDeSucesso
    Vue.prototype.$modalDeErro = modalDeErro
    Vue.prototype.$modalDeInformacao = modalDeInformacao
    Vue.prototype.$modalDeConfirmacao = modalDeConfirmacao
  }
}
/* eslint-enable  @typescript-eslint/no-explicit-any */
_Vue.use(swalPlugin)

_Vue.use(Viewer)

_Vue.config.productionTip = false

new _Vue({
  router,
  i18n,
  store,
  render (h: Function): VNode {
    return h(App)
  }
}).$mount('#app')
